export class IntendedProviderPostParams {
  cash_reward_reference_number?: string;
  client_canonical_id?: string;
  client_canonical_id_source?: string;
  member_number?: string;

  constructor(obj?: IntendedProviderPostParams) {
    if (obj) {
      this.cash_reward_reference_number =
        obj.cash_reward_reference_number || null;
      this.client_canonical_id = obj.client_canonical_id || null;
      this.client_canonical_id_source = obj.client_canonical_id_source || null;
      this.member_number = obj.member_number || null;
    }
  }
}
